import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { AlloyGatorSection } from './components/AlloyGatorSection';
import { HighlightSection } from './components/HighlightSection';
import { USPSection } from './components/USPSection';
import { PortfolioSection } from './components/PortfolioSection';
import { ReviewsSection } from './components/ReviewsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { FixedCTA } from './components/FixedCTA';
import { DemoIndicator } from './components/DemoIndicator';
import { PageTransition } from './components/PageTransition';
import { HelmetProvider } from 'react-helmet-async';
import { Breadcrumbs } from './components/Breadcrumbs';
// Pages
import { HomePage } from './pages/HomePage';
import { DienstenPage } from './pages/DienstenPage';
import { FaqPage } from './pages/FaqPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { OverOnsPage } from './pages/OverOnsPage';
import { LichtenSmokenPage } from './pages/diensten/LichtenSmokenPage';
import { OntchromenPage } from './pages/diensten/OntchromenPage';
import { RamenTintingPage } from './pages/diensten/RamenTintingPage';
import { AlloyGatorPage } from './pages/diensten/AlloyGatorPage';
import { AutoWrappenPage } from './pages/diensten/AutoWrappenPage';
import { ContactPage } from './pages/ContactPage';
import { AfspraakMakenPage } from './pages/AfspraakMakenPage';
import { MaatwerkAdviesPage } from './pages/diensten/MaatwerkAdviesPage';
export function App() {
  return <HelmetProvider data-id="element-0" data-mp="nw2c461hdqr3">
      <Router data-id="element-1" data-mp="nur7k407oeyx">
        <div className="bg-[#0a0a0a] text-white min-h-screen" data-id="element-2" data-mp="nv0x5qhcgk43">
          <Navbar data-id="element-3" data-mp="stuexv3nyxa2" />
          <Breadcrumbs data-id="element-4" data-mp="stc8k5naf2of" />
          <PageTransition data-id="element-5" data-mp="ssstcwp0use3">
            <Routes data-id="element-6" data-mp="36hzxgtw5a5z">
              <Route path="/" element={<HomePage data-id="element-8" data-mp="356r32ll9c80" />} data-id="element-7" data-mp="35oz0whm5evr" />
              <Route path="/diensten" element={<DienstenPage data-id="element-10" data-mp="3udawg7dqol46" />} data-id="element-9" data-mp="38kvshhq5xim" />
              <Route path="/veelgestelde-vragen-faq" element={<FaqPage data-id="element-12" data-mp="d4nwdiwxho3g" />} data-id="element-11" data-mp="3ubzu8bzxzlf6" />
              <Route path="/privacybeleid" element={<PrivacyPage data-id="element-14" data-mp="d3wdn8ofjkul" />} data-id="element-13" data-mp="d4xopd5g47cb" />
              <Route path="/algemene-voorwaarden" element={<TermsPage data-id="element-16" data-mp="86w6svjrae2f" />} data-id="element-15" data-mp="85l28tihl2a9" />
              <Route path="/over-ons" element={<OverOnsPage data-id="element-18" data-mp="3gl4rlhg1e0k1" />} data-id="element-17" data-mp="83i2hhrj7usc" />
              <Route path="/diensten/lichten-smoken" element={<LichtenSmokenPage data-id="element-20" data-mp="3gj1qo2dcin0j" />} data-id="element-19" data-mp="3gmfsn9i3ku7g" />
              <Route path="/diensten/ontchromen" element={<OntchromenPage data-id="element-22" data-mp="3bk702e94zu5v" />} data-id="element-21" data-mp="3bn2zy84joswy" />
              <Route path="/diensten/ramen-tinting" element={<RamenTintingPage data-id="element-24" data-mp="3qcqy50hfjbgg" />} data-id="element-23" data-mp="3qaxulu2457co" />
              <Route path="/diensten/alloygator" element={<AlloyGatorPage data-id="element-26" data-mp="3ljfzhmmru0zm" />} data-id="element-25" data-mp="3lkhg06mk3foq" />
              <Route path="/diensten/autowrappen" element={<AutoWrappenPage data-id="element-28" data-mp="2xu3jo3wxuuoc" />} data-id="element-27" data-mp="3lieg8uvlq86t" />
              <Route path="/diensten/maatwerk-advies" element={<MaatwerkAdviesPage data-id="element-30" data-mp="2sw1yndfycla8" />} data-id="element-29" data-mp="2xtbw9gdhw395" />
              <Route path="/contact" element={<ContactPage data-id="element-32" data-mp="2stzdp7tnpicd" />} data-id="element-31" data-mp="2sv0mf5n79sqx" />
              <Route path="/afspraak-maken" element={<AfspraakMakenPage data-id="element-34" data-mp="18c6p87f6dygh" />} data-id="element-33" data-mp="18d9c849dngr4" />
            </Routes>
          </PageTransition>
          <Footer data-id="element-35" data-mp="1d5j8e2135d1u" />
          <FixedCTA data-id="element-36" data-mp="1d5sqz4jswhxi" />
          <DemoIndicator data-id="element-37" data-mp="1d6axcu06gcj5" />
        </div>
      </Router>
    </HelmetProvider>;
}